import { Injectable } from "@angular/core";
import { IconUtilityService } from "src/app/shared/service/icon-utility-service/icon-utility.service";

@Injectable({
  providedIn: "root",
})
export class CustomerChooseMapService {
  constructor(private iconUtility: IconUtilityService) {}

  cs2ChooseMap(rawValues: Array<any>) {
    return rawValues
      ? rawValues.map((cs2Choose) => ({
          ...cs2Choose,
          roles: cs2Choose.roles.filter((role: string) => !role.includes('RICARICAR')),
          choose: this.getIconChange(cs2Choose),
        }))
      : [];
  }

  getIconChange(csChoosen) {
    return [
      {
        csChoosen: csChoosen,
        icon: this.iconUtility.getMatArrowIcon(),
      },
    ];
  }
}
